import { isDocument, getDocumentIcon } from "foundation/js/utils/communityAttachmentUtils"

export default {
    name: "AttachmentsViewer",
    props: {
        files: {
            type: Array,
            required: true
        }
    },
    setup(props) {
        
        const getLabel = (labelKey) => store.getters['labels/getLabel']({labelCollection: 'AttachmentsViewer', labelKey})

        return {
            getLabel,
            getDocumentIcon,
            isDocument
        }

    }
}